import MeasurementService from "../../services/MeasurementService";

const measurementService = new MeasurementService();

const initialState = {
        id: null,
        created_at: '',
        weight: null,
        neck: null,
        arm: null,
        chest: null,
        waist: null,
        stomach: null,
        hips: null,
        thigh: null,
        calf: null,
        water_percentage: null,
        fat_percentage: null,
        muscle_percentage: null,
        bones_percentage: null,
};

let paginate = {
    rowsPerPage: 50,
    sortBy: 'created_at',
    descending: true,
};

const state = {
    editedMeasurement: Object.assign({}, initialState),
    measurements: {
        data: [],
    },
};

const getters = {
    editedMeasurement: state => state.editedMeasurement,
    measurements: state => state.measurements,
};

const mutations = {
    setEditedMeasurement: (state, measurement) => (state.editedMeasurement = measurement),
    setInitialEditedMeasurement: state => (state.editedMeasurement = Object.assign({}, initialState)),
    setMeasurements: (state, measurements) => (state.measurements = measurements),
};

const actions = {
    async fetchMeasurements({commit}, query) {
        const requestQuery = query !== null && query.hasOwnProperty('params') ? query.params : paginate;
        paginate = requestQuery;

        const {data} = await measurementService.fetchMeasurements(query.patientId, requestQuery);
        commit('setMeasurements', data);
    },
    setInitialEditedMeasurement({commit}) {
        commit('setInitialEditedMeasurement');
    },
    setEditedMeasurement({commit}, measurement) {
      commit('setEditedMeasurement', measurement);
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
